import { useState } from "react";
import FlowWizard from "./FlowWizard";
import FlowChat from "./FlowChat";

export default function FlowPrototype() {
  const [started, setStarted] = useState(false);
  const [ur, setUr] = useState(false);
  return started ? <FlowChat ur={ur} setUr={setUr} /> : <FlowWizard onStart={() => setStarted(true)} />;
}
